<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    坪洲站<br>
站点介绍<br>
坪洲站位于宝安区新湖路与海城路交叉路口，新湖路下，呈东西走向布置，东西走向为新湖路，南北走向为海城路，属地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:26	23:13	1号线	2分钟	4分40秒<br>
机场东	06:07	23:55	1号线	2分钟	4分40秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:33	23:13	1号线	3分45秒	5分45秒<br>
机场东	06:13	23:53	1号线	3分45秒	5分45秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:33	00:13	1号线	3分45秒	5分45秒<br>
机场东	06:13	00:53	1号线	3分45秒	5分45秒<br><br>
<br>
站点出口信息<br>
A出入口:<br>
新湖路北侧（东码头路（北）、河东路、西乡步行街、西乡大门、径贝村、径贝小学、大仟里购物中心<br><br>
B出入口:<br>
新湖路北侧（西）、麻布新村、劳动路口、流塘小学、西乡街道办、麻布居委会、科赫口腔坪洲总店、永丰社区<br><br>
C出入口:<br>
新湖路南侧（西）、海城路、西乡大道、西乡街道劳动管理办公室、大铲湾、海城新村、宝源新村、劳动二队、第一外国语学校（宝安高级中学初中部）<br><br>
D出入口:<br>
新湖路南侧（东）、码头路（南）、西乡派出所、计划生育办、渔业社区居委会、中英公学、坪洲小学、新湖中学、宝安中学附属小学、西乡码头、海滨新村、渔业新村、万色化妆美容美甲学院<br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 西乡麻布社区<br>
M522<br><br>
B出入口:<br>
公交站名： 坪洲地铁站<br>
320、613、M131、M210、M330、M350、M377、M382、M470、M507、M560、高峰专线146<br><br>
C出入口:<br>
公交站名： 坪洲地铁站<br>
320、613、M131、M210、M330、M350、M382、M470、M507、M560、高峰专线146、高峰专线158<br><br>
D出入口:<br>
公交站名： 坪洲地铁站1<br>
B631<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>